import React from 'react';
import { array, bool } from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import styled from 'styled-components';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';

const PrivateCollabWrapper = styled.div`
    display: ${p => (p.show ? 'block' : 'none')}
`;

const Settings = ({ isCreate = false, licenses }) => (
    <Section name="Settings">
        <FormField control={Checkbox} disabled={isCreate} toggle label="Portal" name="portal" />

        <FormField control={Checkbox} toggle label="Deleted" name="deleted" />
        <FormField control={Checkbox} toggle label="Archived" name="archived" />
        <FormField control={Checkbox} toggle label="Private" name="private" />
        <FormField control={Checkbox} toggle label="Closed" name="closed" />
        <PrivateCollabWrapper show={licenses && licenses.indexOf('1') !== -1}>
            <FormField control={Checkbox} toggle label="Private Collaboratory" name="enable_private_collaboratory_feature" />
        </PrivateCollabWrapper>
        <FormField control={Checkbox} toggle label="SmartFill AI (activity scraping + categorization)" name="proxy_a_i" />
        <FormField control={Checkbox} toggle label="SmartLens AI (reporting chat)" name="ai_reporting_chat_enabled" />
        <FormField control={Checkbox} toggle label="Outbound API Widget Tool (activity feed and reports)" name="report_widget_tool_enabled" />
        <FormField control={Checkbox} toggle label="Manage Fields" name="manage_fields_enabled" />
    </Section>
);

Settings.propTypes = {
    isCreate: bool,
    licenses: array,
};

export default Settings;
